import {
	Box,
	styled,
	Typography,
	Divider,
	Grid,
	TextField,
	IconButton,
	MenuItem,
	Button,
	Paper,
	Modal,
	Select,
	Tooltip,
	tooltipClasses,
	InputLabel,
	ClickAwayListener,
	FormControl,
} from '@mui/material';

import React, { useEffect, useRef, useState } from 'react';

import './Charges.css';

import CloseIcon from '@mui/icons-material/Close';

import PersonIcon from '@mui/icons-material/Person';

import {
	addNewCharge,
	getAppointment,
	getCptCodes,
	getDxCodes,
	getPatientList,
	getPracticeStaff,
	PostAttahcmentFile,
	savefilepost,
	postCpt,
	postDx,
	getUserSettings,
	postVisitDatalist,
	getLocation,
	postPatNotes,
	moveToMaximusExport,
} from '../../services/api/apiManager';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

import {
	DatePicker,
	DateTimePicker,
	LocalizationProvider,
	TimePicker,
} from '@mui/x-date-pickers';

import Snackbar from '@mui/material/Snackbar';

import Alert from '@mui/material/Alert';

import CircularProgress from '@mui/material/CircularProgress';

import { useNavigate, useLocation } from 'react-router';

import { useStateValue } from '../../../../src/app/services/state/State';

import Autocomplete from '@mui/material/Autocomplete';

import LoopIcon from '@mui/icons-material/Loop';

export function NewCharge() {
	const [{ patients, practice, locations, providers }, dispatch] =
		useStateValue();
	const practice_id = localStorage.getItem('practice_id');
	const navigate = useNavigate();
	const [searchDxCodes, setSearchDxCodes] = useState('');
	const [search, setSearch] = useState('');
	const [searchRight, setSearchRight] = useState('');
	const [searchSingleDxCodes, setSearchSingleDxCodes] = useState('');
	const [searchCptCodes, setSearchCptCodes] = useState('');
	const [searchSindleCptCodes, setSearchSindleCptCodes] = useState('');
	const [SingleCpt, setSingleCpt] = useState();
	const [SingleDx, setSingleDx] = useState();
	const [loading, setLoading] = useState(false);
	const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
	const [patientLoading, setPatientLoading] = useState(false);
	const [globalCptSearchLoading, setGlobalCptSearchLoading] = useState(false);
	const [dxProgress, setDxProgress] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [tabsDiagnosis, setTabsDiagnosis] = useState('2');
	const [visitDate, setVisitDate] = useState(dayjs());
	const [tabsCpt, setTabsCpt] = useState('2');
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [additionalNotes, setAdditionalNotes] = useState('');
	const [openStatus, setOpenStatus] = useState(false);
	const [providerId, setProviderId] = useState('');
	const [physitionId, setPhysitionId] = useState('');
	const [openPhy, setOpenPhy] = useState(false);
	const [openPhysission, setOpenPhysission] = useState(false);
	const [patient, setPatient] = useState(null);
	const [physision, setPhysision] = useState([]);
	const [cptCodes, setCptCodes] = useState([]);
	const [dxCodes, setDxCodes] = useState([]);
	const [dxCodeInc, setDxCodeInc] = useState(1);
	const [patientData, setPatientData] = useState([]);
	const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
	const [checkBoxCptCodes, setCheckBoxCptCodes] = useState();
	const [openDate, setOpenDate] = useState(false);
	const [openPatient, setOpenPatient] = useState(false);
	const [selectedDxCodes, setSelectedDxCodes] = useState([]);
	const [checkBoxDxCodes, setCheckBoxDxCodes] = useState();
	const [data, getData] = useState('');
	const [searchCptData, setSearchCptData] = useState(null);
	const [searchDxData, setSearchDxData] = useState(null);
	const [changeDxCodes, setChangeDxCodes] = useState(true);
	const [changeCptCodes, setChangeCptCodes] = useState(true);
	const [pastVisitId, setPastVisitId] = useState(null);
	const [value, setValue] = useState(null);
	const [dataSet, setDataSet] = useState(false);
	const [status, setStatus] = useState('');
	const practiceID = localStorage.getItem('practice_id');

	const locationId = useLocation();
	const [showDx, setShowDx] = useState(false);
	const [showCpt, setShowCpt] = useState(false);
	const [searchPatient, setSearchPatient] = useState('');
	const [favoriteDx, setFavoriteDx] = useState([]);
	const [favoriteDxCodes, setFavoriteDxCodes] = useState(null);
	const [favoriteCpt, setFavoriteCpt] = useState([]);
	const [favoriteCptCodes, setFavoriteCptCodes] = useState(null);
	const [visitDataList, setVisitDataList] = useState([]);
	const [sincronizationIcon, setSincronizationIcon] = useState(false);
	const [handleLoading, setHandleLoading] = useState(false);
	const [dxCheckData, setDxCheckData] = useState();
	const [cptCheckData, setCptCheckData] = useState();
	const [selectedCpt, setSelectedCpt] = useState('');
	const [selectedDx, setSelectedDx] = useState('');
	const [allLocations, setAllLocations] = useState([]);
	const [selectedLocation, setSelectedLocation] = useState(null);

	let patientID = locationId?.state?.patient_id;
	const inputSelectedFile = useRef(null);

	const addCpt = {
		Input: searchRight,
	};

	const filterPatientData = patientData?.filter((item) => {
		return item?.Inactive == false || item?.Inactive == null;
	});
	const handleProvider = (e) => {
		setProviderId(e.target.value);
	};
	// search Dx codes through Press Enter key
	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			if (search?.length >= 3) {
				searchDx({
					Input: search,
				});
				setShowDx(true);
			}
		}
	};
	// search Cpt codes through Press Enter key
	const handleKeyPressCpt = (event) => {
		if (event.key === 'Enter') {
			if (searchRight?.length >= 3) {
				searchCpt(addCpt);
			}
			setShowCpt(true);
		}
	};

	const handleClickAwayDxBox = () => {
		setShowDx(false);
	};

	const handleClickAwayCptBox = () => {
		setShowCpt(false);
	};

	const [selectedFiles, setSelectedFiles] = useState([]);

	const handleFileSelect = (event) => {
		const files = Array.from(event.target.files);
		setSelectedFiles((pre) => [...pre, ...files]);
	};

	const handleFileRemove = (fileToRemove) => {
		setSelectedFiles((prevFiles) =>
			prevFiles?.filter((file) => file !== fileToRemove)
		);
		if (inputSelectedFile.current) {
			inputSelectedFile.current.value = [];
		}
	};

	// get Cpt by post method
	const searchCpt = async (data) => {
		setGlobalCptSearchLoading(true);
		try {
			const startTime = performance.now();
			const responce = await postCpt(data);
			const endTime = performance.now();
			const spendTime = endTime - startTime;
			if (!responce?.data?.msg) {
				setSearchCptData(responce?.data);
			} else {
				setSearchCptData([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setGlobalCptSearchLoading(false);
		}
	};

	// get Dx by post method
	const searchDx = async (data) => {
		setGlobalSearchLoading(true);
		try {
			const responce = await postDx(data);
			if (!responce?.data?.msg) {
				setSearchDxData(responce?.data);
			} else {
				setSearchDxData([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setGlobalSearchLoading(false);
		}
	};
	// Favorite codes ICD or Dx
	const favoriteCodes = async (data) => {
		try {
			const responce = await getUserSettings(data);
			setFavoriteDx(
				responce?.data
					?.filter(
						(items) =>
							items?.practice_id === parseInt(practiceID) &&
							(items?.Type === 'ICD' || items?.Type === 'icd')
					)
					?.reverse()
			);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// Favorite codes CPT
	const favoriteCodesCpt = async (data) => {
		try {
			const responce = await getUserSettings(data);
			setFavoriteCpt(
				responce?.data
					?.filter(
						(items) =>
							items?.practice_id === parseInt(practiceID) &&
							(items?.Type === 'CPT' || items?.Type === 'cpt')
					)
					?.reverse()
			);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// handle Modal and get Dx codes
	const handleCloseModal = () => {
		setOpenModal(false);
	};
	const handleOpenModal = async (id) => {
		setOpenModal(true);
	};

	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	// Additional Notes
	const handleChangeStatus = (event) => {
		setStatus(event.target.value);
	};

	// Function to handle checkbox selection
	const handleCheckboxChange = (cptCode) => {
		const isChecked = selectedCheckboxes?.some(
			(item) => item?.CPTCode === cptCode?.CPTCode
		);

		if (isChecked) {
			// Checkbox is already selected, so remove it
			setSelectedCheckboxes((prevSelectedCheckboxes) =>
				prevSelectedCheckboxes?.filter(
					(item) => item?.CPTCode !== cptCode?.CPTCode
				)
			);
		} else {
			// Checkbox is not selected, so add it
			setSelectedCheckboxes((prev) => [...prev, cptCode]);
		}
	};

	// Function to remove a selected checkbox
	// CheckBoxCptCodes
	const handleRemoveCheckbox = (cptCode) => {
		setCheckBoxCptCodes((prevSelectedCheckboxes) =>
			prevSelectedCheckboxes?.filter(
				(item) => item?.CPTCode !== cptCode?.CPTCode
			)
		);
		setSelectedCheckboxes((prevSelectedCheckboxes) =>
			prevSelectedCheckboxes?.filter(
				(item) => item?.CPTCode !== cptCode?.CPTCode
			)
		);
		const element = document.getElementById(cptCode?.CPTCode);
		if (element) {
			element.checked = false;
		}
	};

	// set Dx Codes into array
	const dxCodePOST = checkBoxDxCodes?.map((items, index) => {
		return `Dxcode:${items?.DxCode}`;
	});

	let dxCodeLastLogic = [];
	try {
		for (let i = 0; i < 12; i++) {
			dxCodeLastLogic.push(
				dxCodePOST[i] === undefined ? `Dxcode:null` : `${dxCodePOST[i]}`
			);
		}
	} catch (error) {
		console.warn(error);
	}
	const dxCodePostObj = dxCodeLastLogic?.reduce((acc, currentValue, index) => {
		const [key, value] = currentValue.split(':');
		acc[key + (index + 1)] = value === 'null' ? null : value;
		return acc;
	}, {});
	const dxCodeDescPOST = checkBoxDxCodes?.map((items, index) => {
		return `DxADescription:${items?.Description}`;
	});
	let dxDescLastLogic = [];
	try {
		for (let i = 0; i < 12; i++) {
			dxDescLastLogic.push(
				dxCodeDescPOST[i] === undefined
					? `DxADescription:null`
					: `${dxCodeDescPOST[i]}`
			);
		}
	} catch (error) {
		console.warn(`there is an error of unbound index of an array `, error);
	}

	const dxCodeDescPostObj = dxDescLastLogic?.reduce(
		(acc, currentValue, index) => {
			const [key, value] = currentValue.split(':');
			acc[key.toString().replace('A', index + 1)] =
				value === 'null' ? null : value; // Convert value to integer if needed
			return acc;
		},
		{}
	);

	// checkBox Dx codes
	const handleDxCheckboxChange = (dxCode) => {
		const isChecked = selectedDxCodes?.some(
			(item) => item?.DxCode === dxCode?.DxCode
		);
		if (isChecked) {
			// Checkbox is already selected, so remove it
			setSelectedDxCodes((prevSelectedDxCodes) =>
				prevSelectedDxCodes?.filter((item) => item?.DxCode !== dxCode?.DxCode)
			);
		} else {
			setSelectedDxCodes((prev) => {
				if (prev?.length < 12) {
					return [...prev, dxCode];
				}
				return prev;
			});
			// setSelectedDxCodes((prev) => [...prev, dxCode]);
		}
	};
	const [patientDataLoaded, setPatientDataLoaded] = useState(false);

	//CROSS
	const handleRemoveDxCheckbox = (dxCode) => {
		setCheckBoxDxCodes((prevSelectedDxCodes) =>
			prevSelectedDxCodes?.filter((item) => item?.DxCode !== dxCode?.DxCode)
		);
		setSelectedDxCodes((prevSelectedDxCodes) =>
			prevSelectedDxCodes?.filter((item) => item?.DxCode !== dxCode?.DxCode)
		);
		const element = document.getElementById(dxCode?.DxCode);
		if (element) {
			element.checked = false;
		}
	};
	const getPatientData = async () => {
		if (handleLoading == false) {
			setPatientLoading(true);
		}
		try {
			const response = await getPatientList(practice_id);
			setPatientDataLoaded(true);
			setPatientData(response?.data);
			if (patientDataLoaded == true) {
				setPatientLoading(false);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
			setPatientLoading(false);
		}
	};
	// past visit
	const pastVisitData = () => {
		if (!dataSet && patientDataLoaded) {
			patientData?.some((item) => {
				if (item?.patient_id == patientID) {
					setStatus('D');
					setPatient({
						Name: item?.Name,
						DOB: item?.DOB,
						location: item?.location,
						Provider: item?.provider,
						patient_id: item?.patient_id,
						locationid: item?.locationid,
						providerid: item?.providerid,
						admissionid: item?.admissionid,
					});
					setProviderId(item?.providerid);
					setPhysitionId(item?.referring_id);
					setDataSet(true);
				}
			});
		}
	};
	const getVisitListData = async (data) => {
		try {
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setVisitDataList(response?.data);
			} else {
				setVisitDataList([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	const filterData = {
		practice_id: practiceID,
	};

	//past visit
	const filteredVisitData = visitDataList?.filter((item) => {
		const patientNameMatch = item?.patient_id == patient?.patient_id;
		return patientNameMatch;
	});

	const fetchLocations = async () => {
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				setAllLocations(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Locations:', error);
		}
	};

	// API
	useEffect(() => {
		getVisitListData(filterData);
		pastVisitData();
		getCptCode();
		getPatientData();
		getAppointmentData();
		getDxCode();
		getPractStuff();
		// savefilepost();
		// PostAttahcmentFile();
		favoriteCodes();
		favoriteCodesCpt();
		fetchLocations();
	}, [patientDataLoaded, patient, dataSet]);

	useEffect(() => {
		if (patient != null) {
			visitDataList?.filter((item) => {
				if (item?.patient_id == patient?.patient_id) {
					setSincronizationIcon(true);
				}
			});
		}
	});

	// get practice stuff and physision id
	const getPractStuff = async () => {
		try {
			const response = await getPracticeStaff();
			setPhysision(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Appointment
	const getAppointmentData = async () => {
		try {
			const response = await getAppointment();
			getData(response.data[2]);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// CPT Codes
	const getCptCode = async () => {
		try {
			const response = await getCptCodes();
			setCptCodes(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// Dx Codes
	const getDxCode = async () => {
		try {
			const response = await getDxCodes();
			setDxCodes(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const addCharge = {
		...dxCodePostObj, //using spread operator
		...dxCodeDescPostObj,
		practice_id: practiceID,
		patient_id: patient?.patient_id,
		admission_id: patient?.admissionid,
		// location_id: patient?.locationid || undefined,
		location_id: selectedLocation?.id || undefined,
		practicestaff_id: providerId || undefined,
		referringPhysician_id: physitionId || undefined,
		VisitDate: dayjs(visitDate).format('YYYY-MM-DDTHH:mm:ss'),
		VisitStatus: status,
		AdditionalNotes: additionalNotes,
		visit_cpts: checkBoxCptCodes,
	};

	// const createNewCharge = async (data) => {
	// 	setPatientLoading(true);
	// 	const response = await addNewCharge(data);
	// 	if (response.status === 200 || response.status === 201) {
	// 		for (const element of selectedFiles) {
	// 			if (element) {
	// 				try {
	// 					const formData = new FormData();
	// 					formData.append('file', element);
	// 					formData.append('filepath', practice_id + '/' + response?.data?.id);

	// 					const savefile = await savefilepost(formData);

	// 					const storeFileName = savefile?.data?.file_name;
	// 					const storeFilePath = savefile?.data?.file_path;
	// 					const AttachmentFilePost = {
	// 						visit_id: response?.data?.id,
	// 						patient_id: patient?.patient_id,
	// 						AttachmentName: storeFileName,
	// 						Path: storeFilePath,
	// 						Type: element?.type,
	// 					};
	// 					const attachFile = await PostAttahcmentFile(AttachmentFilePost);
	// 					setPatientLoading(false);
	// 				} catch (error) {
	// 					console.error('Error:', error);
	// 					setPatientLoading(false);
	// 				}
	// 			}
	// 		}
	// 		setPostSucessfully(true);
	// 		setTimeout(() => {
	// 			navigate('/charges');
	// 		}, 1000);
	// 		setAdditionalNotes('');
	// 		setStatus('');
	// 		setCheckBoxDxCodes();
	// 		setCheckBoxCptCodes();
	// 		setOpenPatient(false);
	// 		setPatient(null);
	// 		setProviderId('');
	// 	} else {
	// 		setPostSucessfully(false);
	// 	}
	// 	setOpenSnackbar(true);
	// };

	// handle the select option
	const notes_PatientUpdateInformation = async (data) => {
		try {
			const response = await postPatNotes(data);
			if (response.status === 201) {
				console.log('Status check:', response);
			}
			console.log('Status check:', response);
		} catch (error) {
			console.error('Error:', error);
		}
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const moveToMaximusData = {
		OSW_id: OSW_id,
		visitids: '',
		practice_id: practice_id,
	};
	const createNewCharge = async (data) => {
		debugger;
		setPatientLoading(true);
		try {
			const response = await addNewCharge(data);

			if (response.status === 200 || response.status === 201) {
				// if (OSW_id == '1') {
				// 	moveToMaximusData.visitids = response?.data?.id?.toString();
				// 	const resMaximus = await moveToMaximusExport(moveToMaximusData);
				// 	console.log('res:', resMaximus);
				// }
				// Handle file attachments
				if (selectedFiles.length > 0) {
					for (const element of selectedFiles) {
						if (element) {
							try {
								const formData = new FormData();
								formData.append('file', element);
								formData.append(
									'filepath',
									practice_id + '/' + response?.data?.id
								);

								const savefile = await savefilepost(formData);

								const storeFileName = savefile?.data?.file_name;
								const storeFilePath = savefile?.data?.file_path;

								const AttachmentFilePost = {
									visit_id: response?.data?.id,
									patient_id: patient?.patient_id,
									AttachmentName: storeFileName,
									Path: storeFilePath,
									Type: element?.type,
								};

								await PostAttahcmentFile(AttachmentFilePost);
							} catch (error) {
								console.error('Error uploading file:', error);
							}
						}
					}
				}
				const notes = [
					{ NotesText: 'New charge for patient successfully created.' },
				];

				if (checkBoxDxCodes?.length > 0) {
					notes.push({
						NotesText: `${checkBoxDxCodes.length} Dx Code(s) added.`,
					});
				}

				if (checkBoxCptCodes?.length > 0) {
					notes.push({
						NotesText: `${checkBoxCptCodes.length} CPT Code(s) added.`,
					});
				}

				const notesData = {
					Patientid: patient?.patient_id,
					Visit_id: response?.data?.id,
					practice_id: practiceID,
					NoteCategory: 'charge',
					Platform: 'web',
					Notes: notes,
				};

				try {
					await notes_PatientUpdateInformation(notesData);
				} catch (error) {
					console.error('Error posting notes:', error);
				}

				setPostSucessfully(true);
				setTimeout(() => {
					navigate('/charges');
				}, 1000);

				// Reset state
				setAdditionalNotes('');
				setStatus('');
				setCheckBoxDxCodes([]);
				setCheckBoxCptCodes([]);
				setOpenPatient(false);
				setPatient(null);
				setProviderId('');
			} else {
				setPostSucessfully(false);
			}
		} catch (error) {
			console.error('Error creating charge:', error);
			setPostSucessfully(false);
		} finally {
			setPatientLoading(false);
			setOpenSnackbar(true);
		}
	};

	const handleCloseStatus = () => setOpenStatus(false);
	const handleOpenStatus = () => setOpenStatus(true);

	// formated date and calculate the age
	const dobDate = new Date(patient?.DOB);
	const year = dobDate.getFullYear();
	const month = (dobDate.getMonth() + 1).toString().padStart(2, '0');
	const day = dobDate.getDate().toString().padStart(2, '0');
	const formattedDOB = `${year}-${month}-${day}`;
	const currentDate = new Date();
	// Calculate the age
	let age = currentDate.getFullYear() - dobDate.getFullYear();
	if (
		currentDate.getMonth() < dobDate.getMonth() ||
		(currentDate.getMonth() === dobDate.getMonth() &&
			currentDate.getDate() < dobDate.getDate())
	) {
		age--;
	}

	// filter the Dx codes
	const filteredDxCodes = dxCodes?.filter((item) => {
		const DxCodesMatch =
			!searchDxCodes ||
			`${item?.MinCode} - ${item?.MaxCode}`
				.toLowerCase()
				.includes(searchDxCodes.toLowerCase());
		return DxCodesMatch;
	});

	const formatAdmissionDate = (dateString) => {
		if (!dateString) return null;
		const admissionDate = new Date(dateString);
		const year = admissionDate.getFullYear();
		const month = (admissionDate.getMonth() + 1).toString().padStart(2, '0');
		const day = admissionDate.getDate().toString().padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	// handle Searches DxCodes
	const [searchFavDxCode, setSearchFavDxCode] = useState('');
	const handleDxCodes = (event) => {
		setSearchFavDxCode(event.target.value);
	};
	// Filtering logic Favourite DxCodes...
	const filteredFavDxCodes = favoriteDxCodes?.setting_codes?.filter(
		(item) =>
			item?.Code?.toLowerCase().includes(searchFavDxCode?.toLowerCase()) ||
			item?.CodeDescription?.toLowerCase().includes(
				searchFavDxCode?.toLowerCase()
			)
	);

	// handle Searches Cpt Codes
	const [searchFavCptCode, setSearchFavCptCode] = useState('');
	const handleCptCodes = (event) => {
		setSearchFavCptCode(event.target.value);
	};
	// Filtering logic Favourite Cpt Codes...
	const filteredFavCptCodes = favoriteCptCodes?.setting_codes?.filter(
		(items) =>
			items?.Code?.toLowerCase().includes(searchFavCptCode?.toLowerCase()) ||
			items?.CodeDescription?.toLowerCase().includes(
				searchFavCptCode?.toLowerCase()
			)
	);

	return (
		<>
			{/* {patientLoading ? (
				<Box
					mt={'10px'}
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100%',
						margin: '1rem 0',
					}}
				>
					<CircularProgress />
				</Box>
			) : ( */}
			<Box sx={{ padding: '5px 15px 5px 5px' }}>
				<Grid
					container
					item
					xl={12}
					lg={12}
					md={12}
					sm={12}
					xs={12}
					sx={{ padding: '5px 5px 15px 5px' }}
				>
					<Grid item xl={4.5} lg={4.5} md={4.5} sm={12} xs={12}>
						{!patient && (
							<Box
								sx={{
									width: '100%',
									height: '100%',
									display: 'flex',
									alignItems: 'center',
									padding: '1px 10px',
								}}
							>
								{/* <CustomLeftBox> */}
								<Box display={'flex'} gap={'5px'} alignItems={'center'}>
									<Typography color={'#000000'} fontWeight={500}>
										Select Patient to Proceed{' '}
										<span style={{ color: '#FF0000' }}>*</span>
									</Typography>
									<Box sx={{ display: 'flex' }}>
										{/* autocomplete */}
										<Autocomplete
											size="small"
											value={patient}
											onChange={(event, newValue) => {
												setPatient(newValue);
												if (status?.length <= 0) {
													setStatus('D');
												}
												setProviderId(newValue?.providerid);
												setPhysitionId(newValue?.referring_id);
												setHandleLoading(true);
											}}
											id="country-select-demo"
											sx={{ width: 200 }}
											options={filterPatientData}
											autoHighlight
											getOptionLabel={(option) => option?.Name}
											renderOption={(props, option) => (
												<Box
													component="li"
													sx={{
														'& > img': { mr: 2, flexShrink: 0 },
														display: option?.Inactive == true ? 'none' : 'flex',
													}}
													{...props}
												>
													{option?.Name}
												</Box>
											)}
											renderInput={(params) => (
												<TextField
													{...params}
													label="Select Patient"
													inputProps={{
														...params.inputProps,
														autoComplete: 'new-password',
														autoComplete: 'off',
														placeholder: 'Search By Name.',
													}}
												/>
											)}
										/>
									</Box>
								</Box>
							</Box>
						)}
						{patient && (
							<Box>
								<Box display={'flex'} flexDirection={'column'} gap={'5px'}>
									<Box margin={'5px'}>
										<Box
											display={'flex'}
											flexDirection={'column'}
											sx={{
												border: '0.5px solid #C2C2C2',

												padding: {
													xl: '7px',
													lg: '2px',
													md: '5px',
												},
												background: '#F9F9FC',
												borderRadius: '6px',
												position: 'relative',
											}}
										>
											<Typography
												variant="h6"
												sx={{
													fontFamily: 'Poppins',
													fontSize: {
														xl: '13px',
														lg: '10px',
														md: '9px',
														sm: '9px',
														xs: '9px',
													},
													color: '#BC1111',
													position: 'absolute',
													top: '-10px',
													left: '10px',
													background: '#F9F9FC',
													padding: '0 5px',
												}}
											>
												Patient Info
											</Typography>
											<Box display={'flex'}>
												<Grid
													container
													xl={12}
													lg={12}
													md={12}
													sm={12}
													alignItems={'center'}
													lineHeight={'4'}
													margin={'10px 0'}
												>
													<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
														<Box>
															<Box sx={{ padding: '3px 10px' }}>
																<Box
																	display={'flex'}
																	gap={'5px'}
																	alignItems={'center'}
																>
																	<PersonIcon color="primary" />
																	<Typography
																		color={'#EB0000'}
																		fontWeight={600}
																		fontFamily={'Poppins'}
																		whiteSpace={'nowrap'}
																		sx={{
																			fontSize: {
																				xl: '15px',
																				lg: '10px',
																				md: '9px',
																				sm: '9px',
																				xs: '9px',
																			},
																		}}
																	>
																		{patient?.Name}
																	</Typography>
																</Box>
																<Typography
																	color={'#2E476B'}
																	fontWeight={500}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '9px',
																			sm: '9px',
																			xs: '9px',
																		},
																	}}
																	whiteSpace={'nowrap'}
																>
																	{formattedDOB && !isNaN(age) && (
																		<>
																			{formattedDOB} / {age} yrs{' '}
																			{patient?.Gender}
																		</>
																	)}
																</Typography>
															</Box>
														</Box>
													</Grid>
													<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
														<Box>
															{/*<Typography
																color={'#8F8E8E'}
																fontWeight={400}
																fontFamily={'Poppins'}
																fontSize={'14px'}
																sx={{
																	fontSize: {
																		xl: '15px',
																		lg: '10px',
																		md: '9px',
																		sm: '9px',
																		xs: '9px',
																	},
																}}
															>
																Location
															</Typography>
															 <Typography
																color={'#000000'}
																fontWeight={400}
																fontFamily={'Poppins'}
																sx={{
																	fontSize: {
																		xl: '15px',
																		lg: '10px',
																		md: '9px',
																		sm: '9px',
																		xs: '9px',
																	},
																}}
																//
															>
																{patient?.location}
															</Typography> */}
															{/*<CustomWidthTooltip
																arrow
																title={patient?.location}
																placement="top-start"
															>
																<Typography
																	color={'#000000'}
																	fontWeight={400}
																	fontFamily={'Poppins'}
																	sx={{
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '9px',
																			sm: '9px',
																			xs: '9px',
																		},
																	}}
																>
																	{patient?.location?.length > 15
																		? patient?.location?.slice(0, 15) + '....'
																		: patient?.location}
																</Typography>
															</CustomWidthTooltip>*/}
															<Autocomplete
																disablePortal
																id="combo-box-demo"
																size="small"
																options={allLocations}
																getOptionLabel={(option) => option?.Name || ''}
																value={selectedLocation}
																onChange={(event, newValue) => {
																	setSelectedLocation(newValue);
																}}
																sx={{
																	'.MuiInputBase-root': {
																		height: '40px', // Adjust the input height
																	},
																	'.MuiInputBase-input': {
																		fontSize: '12px', // Adjust input font size
																		color: '#8F8E8E',
																	},
																	'.MuiAutocomplete-option': {
																		fontSize: '12px', // Adjust dropdown option font size
																	},
																	width: 200,
																	height: {
																		xl: '40px',
																		lg: '40px',
																		md: '40px',
																		sm: '40px',
																		xs: '40px',
																	},
																}}
																renderInput={(params) => (
																	<TextField {...params} label="Locations" />
																)}
															/>
														</Box>
													</Grid>
												</Grid>
												{/* </Box> */}
												<Box
													display={'flex'}
													flexDirection={'column'}
													justifyContent={'space-between'}
													width={'25%'}
													alignItems={'flex-end'}
												>
													<IconButton
														sx={{ ml: 'auto' }}
														onClick={() => {
															setPatient(null);
															setPastVisitId(null);
															setSincronizationIcon(false);
															setSelectedCheckboxes([]);
															setCheckBoxCptCodes();
															setCheckBoxDxCodes();
															setSelectedDxCodes([]);
														}}
													>
														<CloseIcon
															sx={{
																color: '#ED2828',

																fontSize: {
																	xl: '19px',
																	lg: '14px',
																	md: '12px',
																	sm: '12px',
																	xs: '12px',
																},
															}}
														/>
													</IconButton>
													<Box
														display={'flex'}
														gap={'5px'}
														alignItems={'center'}
														sx={{
															display: sincronizationIcon ? 'flex' : 'none',
														}}
													>
														<Typography
															color={'#8F8E8E'}
															fontWeight={400}
															fontFamily={'Poppins'}
															fontSize={'14px'}
															sx={{
																fontSize: {
																	xl: '15px',
																	lg: '10px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
															}}
														>
															Past Visits
														</Typography>

														<IconButton
															onClick={() => {
																handleOpenModal();
																setSelectedDx('');
																setSelectedCpt('');
															}}
															sx={{
																width: '30px',
																height: '30px',
																cursor: 'pointer',
															}}
														>
															<LoopIcon
																sx={{
																	fontSize: {
																		xl: '19px',
																		lg: '16px',
																		md: '13px',
																		sm: '12px',
																		xs: '12px',
																	},
																}}
															/>
														</IconButton>
													</Box>
												</Box>
											</Box>
										</Box>
									</Box>
								</Box>
							</Box>
						)}
					</Grid>
					<Grid item xl={7.5} lg={7.5} md={7.5} sm={12} xs={12}>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								border: '1px solid lightgray',
								borderRadius: '6px',

								padding: {
									xl: '15px',
									lg: '10px',
									md: '10px',
									sm: '10px',
									xs: '10px',
								},
								margin: '5px',
								background: '#F9F9FC',
								position: 'relative',
							}}
						>
							<Typography
								color={'#BC1111'}
								fontWeight={500}
								fontFamily={'Poppins'}
								sx={{
									fontSize: {
										xl: '13px',
										lg: '10px',
										md: '10px',
										sm: '10px',
										xs: '10px',
									},
									position: 'absolute',
									top: '-10px', // Adjust position as needed
									left: '10px', // Adjust position as needed
									background: '#F9F9FC', // Match with parent background color
									padding: '0 5px', //
								}}
							>
								Charge Info
							</Typography>
							<Box>
								<Grid
									container
									spacing={2}
									sx={{ display: 'flex', alignItems: 'flex-end' }}
								>
									{/* item1 */}
									<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
										<FormControl fullWidth size="small">
											<InputLabel htmlFor="demo-select-small">
												{' '}
												Status <span style={{ color: '#FF0000' }}>*</span>{' '}
											</InputLabel>
											<Select
												labelId="demo-select-small-label"
												id="demo-select-small"
												label={'status'}
												value={status}
												open={openStatus}
												onChange={handleChangeStatus}
												onClose={handleCloseStatus}
												fullWidth
												sx={{
													color: '#8F8E8E',
													fontSize: {
														xl: '19px',
														lg: '14px',
														md: '12px',
														sm: '12px',
														xs: '12px',
													},
													height: {
														xl: '40px',
														lg: '40px',
														md: '40px',
														sm: '40px',
														xs: '40px',
													},
												}}
												onOpen={handleOpenStatus}
												clicking
												outside
											>
												<MenuItem value="D">Draft</MenuItem>
												<MenuItem value="B">Billed</MenuItem>
												<MenuItem value="A">Approved</MenuItem>
												<MenuItem value="O">Other</MenuItem>
											</Select>
										</FormControl>
									</Grid>
									{/* item2 */}
									<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
										<LocalizationProvider dateAdapter={AdapterDayjs}>
											<DemoContainer components={['DatePicker']}>
												<DemoItem>
													<DateTimePicker
														value={visitDate}
														size="small"
														label={'Charge Date'}
														onChange={(newValue) => setVisitDate(newValue)}
														open={openDate}
														onOpen={() => setOpenDate(true)}
														onClose={() => setOpenDate(false)}
														onClick={() => setOpenDate(true)}
														slotProps={{
															textField: {
																fontSize: {
																	xl: '13px',
																	lg: '10px',
																	md: '10px',
																	sm: '10px',
																	xs: '10px',
																},
																size: 'small',
															},
														}}
													/>
												</DemoItem>
											</DemoContainer>
										</LocalizationProvider>
									</Grid>
									{/* item 3 */}
									<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
										<FormControl fullWidth size="small">
											<InputLabel htmlFor="demo-select-small">
												{' '}
												Provider
											</InputLabel>
											<Select
												labelId="demo-select-small-label"
												id="demo-select-small"
												label={'Provider'}
												value={providerId}
												onChange={handleProvider}
												fullWidth
												sx={{
													color: '#8F8E8E',
													fontSize: {
														xl: '19px',
														lg: '14px',
														md: '12px',
														sm: '12px',
														xs: '12px',
													},
													height: {
														xl: '40px',
														lg: '40px',
														md: '40px',
														sm: '40px',
														xs: '40px',
													},
												}}
												open={openPhy}
												onClose={() => setOpenPhy(false)}
												onOpen={() => setOpenPhy(true)}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '300px',
															width: '130px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
											>
												{physision?.map((item, key) => {
													return (
														<MenuItem key={key} value={item?.id}>
															{item?.Lname + ', ' + item?.Fname}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Grid>
									<Grid item xl={3} lg={3} md={3} sm={3} xs={6}>
										<FormControl fullWidth size="small">
											<InputLabel> Referring Phy </InputLabel>
											<Select
												labelId="demo-select-small-label"
												id="demo-select-small"
												label={'Referring Phy *'}
												value={physitionId}
												onChange={(e) => setPhysitionId(e.target.value)}
												fullWidth
												sx={{
													color: '#8F8E8E',
													fontSize: {
														xl: '19px',
														lg: '14px',
														md: '12px',
														sm: '12px',
														xs: '12px',
													},
													height: {
														xl: '40px',
														lg: '40px',
														md: '40px',
														sm: '40px',
														xs: '40px',
													},
												}}
												open={openPhysission}
												onClose={() => setOpenPhysission(false)}
												onOpen={() => setOpenPhysission(true)}
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: '300px',
															width: '130px',
															overflowY: 'auto',
															scrollbarWidth: 'thin',
															scrollbarColor: 'dark',
															msOverflowStyle: 'none',
															WebkitOverflowScrolling: 'touch',
														},
													},
												}}
											>
												{physision?.map((item, key) => {
													return (
														<MenuItem key={key} value={item?.id}>
															{item?.Lname + ', ' + item?.Fname}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Grid>
									{/* item4 */}
								</Grid>
							</Box>
						</Box>
					</Grid>
				</Grid>

				{/* Add Diagonis and add CPT Codes */}

				<Grid container spacing={1} sx={{ overflow: 'auto' }}>
					{/* Add dx Diagnosis */}
					<Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
						<Box display={'flex'} flexDirection={'column'}>
							<Box>
								<ClickAwayListener onClickAway={handleClickAwayDxBox}>
									<Box
										sx={{
											borderRadius: '7px',
											pb: '1rem',
											bgcolor: '#FAFAFA',
											border: '1px solid #00000014',
										}}
									>
										{/* head */}
										<DiagnosisBox>
											<Grid display={'flex'} alignItems={'center'}>
												<Typography
													color={'#FFFFFF'}
													fontWeight={500}
													fontFamily={'Poppins'}
													sx={{
														fontSize: {
															xl: '14px',
															lg: '13px',
															md: '9px',
															sm: '9px',
															xs: '9px',
														},
													}}
												>
													Add Dx Codes
												</Typography>
											</Grid>
											{/* search dx codes */}
											<Box display={'flex'} alignItems={'center'} gap={'5px'}>
												<Autocomplete
													size="small"
													value={favoriteDxCodes}
													onChange={(event, newValue) => {
														setFavoriteDxCodes(newValue);
														if (!newValue || newValue?.length === 0) {
															setShowDx(false);
														} else {
															setShowDx(true);
														}
														setSearchDxData(null);
														setSearch('');
													}}
													id="country-select-demo"
													sx={{
														width: 150,
														backgroundColor: 'white',
														borderRadius: '1.2rem',
														height: {
															xl: '33px',
															lg: '33px',
															md: '33px',
															sm: '33px',
															xs: '33px',
														},
														'.MuiInputBase-root': {
															height: {
																xl: '33px',
																lg: '33px',
																md: '33px',
																sm: '33px',
																xs: '33px',
															},
														},
													}}
													options={favoriteDx}
													autoHighlight
													getOptionLabel={(option) => option?.SettingName}
													renderOption={(props, option) => (
														<Box
															component="li"
															sx={{
																'& > img': { mr: 2, flexShrink: 0 },
																borderRadius: '1.2rem',
																fontSize: '13px',
															}}
															{...props}
														>
															{option?.SettingName}
														</Box>
													)}
													renderInput={(params) => (
														<StyledTextField
															{...params}
															label="Favourite"
															inputProps={{
																...params.inputProps,
																autoComplete: 'off',
																placeholder: 'Search By List.',
															}}
															sx={{
																height: {
																	xl: '33px',
																	lg: '33px',
																	md: '33px',
																	sm: '33px',
																	xs: '33px',
																},
																'.MuiInputBase-input': {
																	height: '100%',
																	boxSizing: 'border-box',
																	padding: '0 14px',
																},
															}}
														/>
													)}
												/>
												<input
													value={search}
													onKeyPress={handleKeyPress}
													onChange={(e) => {
														setSearch(e.target.value);
														setFavoriteDxCodes(null);
													}}
													onClick={() => {
														if (searchDxData?.length > 0) {
															setShowDx(!showDx);
														}
													}}
													style={{
														boxShadow: 'none',
														border: '1px solid #00000030',
														borderRadius: '1.2rem',
														height: {
															xl: '30px',
															lg: '30px',
															md: '30px',
															sm: '30px',
															xs: '30px',
														},
														padding: '5px 10px',
														width: '9rem',
													}}
													size="small"
													id="searchInput"
													placeholder="Search..."
												/>
												<Button
													onClick={() => {
														searchDx({
															Input: search,
														});
														setShowDx(true);
													}}
													disabled={search?.length < 3 ? true : false}
													sx={{
														textTransform: 'capitalize',
														height: {
															xl: '15px',
															lg: '15px',
															md: '12px',
															sm: '12px',
															xs: '12px',
														},
														fontSize: {
															xl: '14px',
															lg: '13px',
															md: '10px',
															sm: '10px',
															xs: '10px',
														},
														width: '5rem',
														fontWeight: 300,
														borderRadius: '10rem',
														padding: '15px 20px',
														bgcolor: 'white',
														color: 'black',
														'&:hover': {
															backgroundColor: 'white',
														},
													}}
													variant="contained"
												>
													Search
												</Button>
											</Box>
											{/* </Box> */}
										</DiagnosisBox>
										<Box
											sx={{
												minHeight: '12rem',
											}}
										>
											{searchDxData == null && !showDx && (
												<Grid
													width={'100%'}
													display={
														checkBoxDxCodes?.length <= 0 ||
														checkBoxDxCodes == undefined
															? 'flex'
															: 'none'
													}
													justifyContent={'center'}
													alignItems={'center'}
													height={'100%'}
													sx={{
														fontSize: {
															xl: '15px',
															lg: '10px',
															md: '9px',
															sm: '9px',
															xs: '9px',
														},
													}}
												>
													{' '}
													Write a Code or Description to search
												</Grid>
											)}
											{/* Button Above Favorite Dx Codes */}
											{favoriteDxCodes != null && (
												<Box
													sx={{
														display: 'flex',
														alignItems: 'center',
														height: '50px',
														mr: '1rem',
														justifyContent: 'flex-end',
													}}
												>
													<TextField
														id="outlined-basic"
														placeholder="Search Dx Codes"
														variant="outlined"
														size="small"
														value={searchFavDxCode}
														onChange={handleDxCodes}
														sx={{
															'& .MuiOutlinedInput-root': {
																borderRadius: '1rem', // Adjust border radius
																height: '35px', // Adjust height
																fontSize: '12px', // Adjust font size
															},
															'& .MuiInputLabel-root': {
																fontSize: '12px', // Adjust label font size
															},
															'& .MuiOutlinedInput-input': {
																fontSize: '12px', // Adjust input text font size
															},
														}}
													/>
												</Box>
											)}
											<Box
												sx={{
													opacity: showDx ? 1 : 0,
													height: {
														xl: showDx ? '29vh' : '0px',
														lg: showDx ? '29vh' : '0px',
														md: showDx ? '29vh' : '0px',
														sm: showDx ? '27vh' : '0px',
														xs: showDx ? '25vh' : '0px',
													},
													transition: 'all 0.4s ease-in-out',
													border: showDx ? '1px solid #00000026' : 'none',
													backgroundColor: 'white',
													margin: '0px 5px 5px 5px',
													borderBottomRightRadius: '5px',
													borderBottomLeftRadius: '5px',
												}}
											>
												<Box
													sx={{
														opacity: showDx ? 1 : 0,
														height: {
															xl: showDx ? '30vh' : '0px',
															lg: showDx ? '30vh' : '0px',
															md: showDx ? '30vh' : '0px',
															sm: showDx ? '28vh' : '0px',
															xs: showDx ? '26vh' : '0px',
														},
														transition: 'all 1s ease-in-out',
													}}
												>
													{globalSearchLoading ? (
														<Box
															sx={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																height: '100%',
																opacity: showDx ? 1 : 0,
																height: {
																	xl: showDx ? '24vh' : '0',
																	lg: showDx ? '24vh' : '0',
																	md: showDx ? '24vh' : '0',
																	sm: showDx ? '22vh' : '0',
																	xs: showDx ? '20vh' : '0',
																},
																transition: 'height 0.7s ease-in-out',
															}}
														>
															<CircularProgress />
														</Box>
													) : (
														<Box
															sx={{
																opacity: showDx ? 1 : 0,
																height: {
																	xl: showDx ? '24vh' : '0px',
																	lg: showDx ? '24vh' : '0px',
																	md: showDx ? '24vh' : '0px',
																	sm: showDx ? '22vh' : '0px',
																	xs: showDx ? '20vh' : '0px',
																},
																overflowY: 'auto',
																'&::-webkit-scrollbar': {
																	width: '3.5px',
																},
																'&::-webkit-scrollbar-track': {
																	background: '#f1f1f1',
																},
																'&::-webkit-scrollbar-thumb': {
																	background: '#2E68BA',
																	borderRadius: '5px',
																},
																transition: 'all 0.7s ease-in-out',
															}}
															display={showDx ? 'flex' : 'none'}
															flexDirection={'column'}
														>
															{searchDxData?.length === 0 && (
																<Grid
																	width={'100%'}
																	display={'flex'}
																	justifyContent={'center'}
																	alignItems={'center'}
																	height={'100%'}
																>
																	{' '}
																	No Match Found
																</Grid>
															)}
															{searchDxData == null &&
																favoriteDxCodes == null &&
																showDx && (
																	<Grid
																		width={'100%'}
																		display={'flex'}
																		justifyContent={'center'}
																		alignItems={'center'}
																		height={'100%'}
																		sx={{
																			fontSize: {
																				xl: '15px',
																				lg: '10px',
																				md: '9px',
																				sm: '9px',
																				xs: '9px',
																			},
																		}}
																	>
																		{' '}
																		Write a Code or Description to search
																	</Grid>
																)}
															{}
															{searchDxData != null
																? searchDxData?.map((item, key) => {
																		return (
																			<Box key={key} sx={{ m: '8px 0 0 2rem' }}>
																				<Box display={'flex'} gap={'10px'}>
																					<Grid display={'flex'} gap={'10px'}>
																						<input
																							checked={selectedDxCodes?.some(
																								(items) =>
																									items?.DxCode == item?.Code
																							)}
																							type="checkbox"
																							id={item?.Code}
																							onClick={() => {
																								handleDxCheckboxChange({
																									DxCode: item?.Code,
																									Description:
																										item?.Description,
																								});
																							}}
																							style={{ cursor: 'pointer' }}
																						/>
																						<Grid minWidth={'70px'}>
																							<label
																								htmlFor={item?.Code}
																								style={{
																									color: '#1D60C5',
																									fontWeight: 600,
																									fontFamily: 'Poppins',
																									fontSize: {
																										xl: '15px',
																										lg: '10px',
																										md: '9px',
																										sm: '9px',
																										xs: '9px',
																									},
																									cursor: 'pointer',
																								}}
																							>
																								{`${item?.Code}`}
																							</label>
																						</Grid>
																					</Grid>
																					<Box
																						display={'flex'}
																						alignItems={'center'}
																					>
																						<CustomWidthTooltip
																							arrow
																							title={item?.Description}
																							placement="top-start"
																						>
																							<Typography
																								fontWeight={400}
																								fontFamily={'Poppins'}
																								sx={{
																									fontSize: {
																										xl: '15px',
																										lg: '10px',
																										md: '9px',
																										sm: '9px',
																										xs: '9px',
																									},
																								}}
																							>
																								{item?.Description?.length > 65
																									? item?.Description?.slice(
																											0,
																											65
																										) + '....'
																									: item?.Description}
																							</Typography>
																						</CustomWidthTooltip>
																					</Box>
																				</Box>

																				<Divider color={'#DCE8FB'} />
																			</Box>
																		);
																	})
																: filteredFavDxCodes != null
																	? filteredFavDxCodes?.map((item, key) => {
																			return (
																				<Box
																					key={key}
																					sx={{ m: '8px 0 0 2rem' }}
																				>
																					<Box display={'flex'} gap={'10px'}>
																						<Grid display={'flex'} gap={'10px'}>
																							<input
																								checked={selectedDxCodes?.some(
																									(items) =>
																										items?.DxCode == item?.Code
																								)}
																								type="checkbox"
																								id={item?.Code}
																								onClick={() => {
																									handleDxCheckboxChange({
																										DxCode: item?.Code,
																										Description:
																											item?.CodeDescription,
																									});
																								}}
																								style={{
																									cursor: 'pointer',
																								}}
																							/>
																							<Grid minWidth={'70px'}>
																								<label
																									htmlFor={item?.Code}
																									style={{
																										color: '#1D60C5',
																										fontWeight: 600,
																										fontFamily: 'Poppins',
																										fontSize: {
																											xl: '15px',
																											lg: '10px',
																											md: '9px',
																											sm: '9px',
																											xs: '9px',
																										},
																										cursor: 'pointer',
																									}}
																								>
																									{`${item?.Code}`}
																								</label>
																							</Grid>
																						</Grid>
																						<Box
																							display={'flex'}
																							alignItems={'center'}
																						>
																							<CustomWidthTooltip
																								arrow
																								title={item?.CodeDescription}
																								placement="top-start"
																							>
																								<Typography
																									fontWeight={400}
																									fontFamily={'Poppins'}
																									sx={{
																										fontSize: {
																											xl: '15px',
																											lg: '10px',
																											md: '9px',
																											sm: '9px',
																											xs: '9px',
																										},
																									}}
																								>
																									{item?.CodeDescription
																										?.length > 65
																										? item?.CodeDescription?.slice(
																												0,
																												65
																											) + '....'
																										: item?.CodeDescription}
																								</Typography>
																							</CustomWidthTooltip>
																						</Box>
																					</Box>

																					<Divider color={'#DCE8FB'} />
																				</Box>
																			);
																		})
																	: ''}
														</Box>
													)}
													<Box
														display={'flex'}
														sx={{
															opacity: showDx ? 1 : 0,
															height: showDx ? '30px' : '0px',
															transition: 'all 0.5s ease-in',
														}}
														gap={'5px'}
														justifyContent={'flex-end'}
														margin={'auto 5px 5px 5px'}
													>
														<Button
															onClick={() => {
																setSearchDxData(null);
																setShowDx(false);
																setSelectedDxCodes([]);
																setSearch('');
															}}
															variant="contained"
															sx={{
																backgroundColor: '#ED2828',
																fontSize: {
																	xl: '15px',
																	lg: '10px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
																'&:hover': {
																	backgroundColor: '#ED2828',
																},
															}}
														>
															Cancel
														</Button>
														<Button
															disabled={
																selectedDxCodes?.length <= 0 ||
																selectedDxCodes == undefined
																	? true
																	: false
															}
															onClick={() => {
																setCheckBoxDxCodes(selectedDxCodes);
																setSearchDxData(null);
																setShowDx(false);
																setSearch('');
															}}
															variant="contained"
															sx={{
																backgroundColor: '#D76A05',
																fontSize: {
																	xl: '15px',
																	lg: '10px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
																'&:hover': {
																	backgroundColor: '#D76A05',
																},
															}}
														>
															Add
														</Button>
													</Box>
												</Box>
											</Box>

											{/* close dx codes */}
											{checkBoxDxCodes?.length > 0 && !showDx && (
												<Box
													display={'flex'}
													flexDirection={'column'}
													gap={'5px'}
													m={'5px 0'}
													padding={'0 2px'}
													sx={{
														height: {
															xl: '24vh',
															lg: '29vh',
															md: '29vh',
															sm: '27vh',
															xs: '25vh',
														},
														overflow: 'auto',
													}}
												>
													{checkBoxDxCodes?.map((item, i) => (
														<Box key={i}>
															{changeDxCodes && checkBoxDxCodes?.length > 0 && (
																<Box>
																	<Paper>
																		<CustomBoxDiagosis>
																			<Box
																				display={'flex'}
																				alignItems={'center'}
																			>
																				<CustomWidthTooltip
																					arrow
																					title={`${item?.DxCode} [ ${item?.Description}]`}
																					placement="top-start"
																				>
																					<Typography
																						sx={{
																							color: '#065AD8',
																							fontWeight: 400,
																							fontFamily: 'Poppins',
																							fontSize: {
																								xl: '15px',
																								lg: '10px',
																								md: '9px',
																								sm: '9px',
																								xs: '9px',
																							},
																							lineHeight: '22.5px',
																						}}
																					>
																						{item?.DxCode +
																							` [ ${item?.Description?.length > 55 ? item?.Description?.slice(0, 55) + '...' : item.Description}] `}
																					</Typography>
																				</CustomWidthTooltip>
																			</Box>
																			<Box>
																				<IconButton
																					sx={{
																						ml: 'auto',
																						width: '25px',
																						height: '25px',
																					}}
																					id="myButton"
																					onClick={() =>
																						handleRemoveDxCheckbox(item)
																					}
																				>
																					<CloseIcon
																						sx={{ color: '#ED2828' }}
																					/>
																				</IconButton>
																			</Box>
																		</CustomBoxDiagosis>
																	</Paper>
																</Box>
															)}
														</Box>
													))}
												</Box>
											)}
										</Box>
									</Box>
								</ClickAwayListener>
							</Box>
						</Box>
					</Grid>
					{/* Add CPT Diagnosis */}
					<Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
						<Box display={'flex'} flexDirection={'column'}>
							<Box>
								<Box>
									<ClickAwayListener onClickAway={handleClickAwayCptBox}>
										<Box
											sx={{
												pb: '1rem',
												bgcolor: '#FAFAFA',
												border: '1px solid #00000014',
												borderRadius: '7px',
											}}
										>
											{/* head */}
											<DiagnosisBox>
												<Box display={'flex'} alignItems={'center'}>
													<Typography
														color={'#FFFFFF'}
														fontWeight={500}
														fontFamily={'Poppins'}
														sx={{
															fontSize: {
																xl: '14px',
																lg: '13px',
																md: '10px',
																sm: '9px',
																xs: '9px',
															},
														}}
													>
														Add CPT Codes
													</Typography>
												</Box>

												<Box display={'flex'} gap={'5px'} alignItems={'center'}>
													{
														<Autocomplete
															size="small"
															value={favoriteCptCodes}
															onChange={(event, newValue) => {
																setFavoriteCptCodes(newValue);
																if (!newValue || newValue?.length === 0) {
																	setShowCpt(false);
																} else {
																	setShowCpt(true);
																}
																setSearchCptData(null);
																setSearchRight('');
															}}
															id="country-select-demo"
															sx={{
																width: 150,
																backgroundColor: 'white',
																borderRadius: '1.2rem',
																height: {
																	xl: '33px',
																	lg: '33px',
																	md: '33px',
																	sm: '33px',
																	xs: '33px',
																},
																'.MuiInputBase-root': {
																	height: {
																		xl: '33px',
																		lg: '33px',
																		md: '33px',
																		sm: '33px',
																		xs: '33px',
																	},
																},
															}}
															options={favoriteCpt}
															autoHighlight
															getOptionLabel={(option) => option?.SettingName}
															renderOption={(props, option) => (
																<Box
																	component="li"
																	sx={{
																		'& > img': { mr: 2, flexShrink: 0 },
																		borderRadius: '1.2rem',
																	}}
																	{...props}
																>
																	{option?.SettingName}
																</Box>
															)}
															renderInput={(params) => (
																<StyledTextField
																	{...params}
																	label="Favourite"
																	inputProps={{
																		...params.inputProps,
																		autoComplete: 'new-password',
																		autoComplete: 'off',
																		placeholder: 'Search By List.',
																	}}
																	sx={{
																		height: {
																			xl: '33px',
																			lg: '33px',
																			md: '33px',
																			sm: '33px',
																			xs: '33px',
																		},
																		'.MuiInputBase-input': {
																			height: '100%',
																			boxSizing: 'border-box',
																			padding: '0 14px',
																		},
																	}}
																/>
															)}
														/>
													}
													<input
														value={searchRight}
														onKeyPress={handleKeyPressCpt}
														onChange={(e) => {
															const targetValue = e.target.value;
															setSearchRight(targetValue);
															setFavoriteCptCodes(null);
														}}
														onClick={() => {
															if (searchCptData?.length > 0) {
																setShowCpt(!showCpt);
															}
														}}
														style={{
															boxShadow: 'none',
															border: '1px solid #00000030',
															borderRadius: '1.2rem',
															height: {
																xl: '30px',
																lg: '30px',
																md: '30px',
																sm: '30px',
																xs: '30px',
															},
															width: '9rem',
															padding: '5px 10px',
														}}
														size="small"
														id="searchCpt"
														placeholder="Search..."
													/>
													<Button
														onClick={() => {
															searchCpt(addCpt);
															setShowCpt(true);
														}}
														disabled={searchRight?.length < 3 ? true : false}
														sx={{
															textTransform: 'capitalize',
															height: {
																xl: '15px',
																lg: '15px',
																md: '12px',
																sm: '12px',
																xs: '12px',
															},
															fontSize: {
																xl: '14px',
																lg: '13px',
																md: '10px',
																sm: '10px',
																xs: '10px',
															},
															width: '5rem',
															fontWeight: 300,
															borderRadius: '10rem',
															padding: '15px 20px',
															bgcolor: 'white',
															color: 'black',
															'&:hover': {
																backgroundColor: 'white',
															},
														}}
														variant="contained"
													>
														Search
													</Button>
												</Box>
											</DiagnosisBox>
											<Box
												sx={{
													minHeight: '12rem',
												}}
											>
												{!showCpt && (
													<Grid
														width={'100%'}
														display={
															checkBoxCptCodes?.length <= 0 ||
															checkBoxCptCodes == undefined
																? 'flex'
																: 'none'
														}
														justifyContent={'center'}
														alignItems={'center'}
														height={'100%'}
														sx={{
															fontSize: {
																xl: '15px',
																lg: '10px',
																md: '9px',
																sm: '9px',
																xs: '9px',
															},
														}}
													>
														{' '}
														Write a Code or Description to search
													</Grid>
												)}
												{/* Button Above Favorite CPT Codes */}
												{favoriteCptCodes != null && (
													<Box
														sx={{
															display: 'flex',
															alignItems: 'center',
															height: '50px',
															mr: '1rem',
															justifyContent: 'flex-end',
														}}
													>
														<TextField
															id="outlined-basic"
															placeholder="Search Cpt Codes"
															variant="outlined"
															size="small"
															value={searchFavCptCode}
															onChange={handleCptCodes}
															sx={{
																'& .MuiOutlinedInput-root': {
																	borderRadius: '1rem', // Adjust border radius
																	height: '35px', // Adjust height
																	fontSize: '12px', // Adjust font size
																},
																'& .MuiInputLabel-root': {
																	fontSize: '12px', // Adjust label font size
																},
																'& .MuiOutlinedInput-input': {
																	fontSize: '12px', // Adjust input text font size
																},
															}}
														/>
													</Box>
												)}
												<Box
													sx={{
														opacity: showCpt ? 1 : 0,
														height: {
															xl: showCpt ? '29vh' : '0',
															lg: showCpt ? '29vh' : '0',
															md: showCpt ? '29vh' : '0',
															sm: showCpt ? '27vh' : '0',
															xs: showCpt ? '25vh' : '0',
														},
														transition: 'all 0.4s ease-in-out',
														border: showCpt ? '1px solid #00000026' : 'none',
														margin: '0px 5px 5px 5px',
														borderBottomRightRadius: '5px',
														borderBottomLeftRadius: '5px',
														backgroundColor: 'white',
													}}
												>
													<Box
														sx={{
															opacity: showCpt ? 1 : 0,
															height: {
																xl: showCpt ? '30vh' : '0',
																lg: showCpt ? '30vh' : '0',
																md: showCpt ? '30vh' : '0',
																sm: showCpt ? '28vh' : '0',
																xs: showCpt ? '26vh' : '0',
															},
															transition: 'all 1s ease-in-out',
														}}
													>
														{globalCptSearchLoading ? (
															<Grid
																sx={{
																	display: 'flex',
																	justifyContent: 'center',
																	alignItems: 'center',
																	height: '100%',
																	opacity: showCpt ? 1 : 0,
																	height: {
																		xl: showCpt ? '24vh' : '0',
																		lg: showCpt ? '24vh' : '0',
																		md: showCpt ? '24vh' : '0',
																		sm: showCpt ? '22vh' : '0',
																		xs: showCpt ? '20vh' : '0',
																	},
																	transition: 'height 0.7s ease-in-out',
																}}
															>
																<CircularProgress />
															</Grid>
														) : (
															<Grid
																sx={{
																	opacity: showCpt ? 1 : 0,
																	height: {
																		xl: showCpt ? '24vh' : '0',
																		lg: showCpt ? '24vh' : '0',
																		md: showCpt ? '24vh' : '0',
																		sm: showCpt ? '22vh' : '0',
																		xs: showCpt ? '20vh' : '0',
																	},
																	overflowY: 'auto',
																	'&::-webkit-scrollbar': {
																		width: '3.5px',
																	},
																	'&::-webkit-scrollbar-track': {
																		background: '#f1f1f1',
																	},
																	'&::-webkit-scrollbar-thumb': {
																		background: '#2E68BA',
																		borderRadius: '5px',
																	},
																	transition: 'height 0.7s ease-in-out',
																}}
																display={showCpt ? 'flex' : 'none'}
																flexDirection={'column'}
															>
																{searchCptData?.length === 0 && (
																	<Grid
																		width={'100%'}
																		display={'flex'}
																		justifyContent={'center'}
																		alignItems={'center'}
																		height={'100%'}
																	>
																		{' '}
																		No Match Found
																	</Grid>
																)}
																{searchCptData == null &&
																	favoriteCptCodes == null &&
																	showCpt && (
																		<Grid
																			width={'100%'}
																			display={'flex'}
																			justifyContent={'center'}
																			alignItems={'center'}
																			height={'100%'}
																			sx={{
																				fontSize: {
																					xl: '15px',
																					lg: '10px',
																					md: '9px',
																					sm: '9px',
																					xs: '9px',
																				},
																			}}
																		>
																			{' '}
																			Write a Code or Description to search
																		</Grid>
																	)}

																{searchCptData != null
																	? searchCptData?.map((item, key) => {
																			return (
																				<Box
																					key={key}
																					sx={{ m: '8px 0 0 2rem' }}
																				>
																					<Box display={'flex'} gap={'10px'}>
																						<Grid display={'flex'} gap={'10px'}>
																							<input
																								type="checkbox"
																								checked={selectedCheckboxes?.some(
																									(items) =>
																										items?.CPTCode == item?.Code
																								)}
																								id={item?.Code}
																								onClick={() => {
																									handleCheckboxChange({
																										CPTCode: item?.Code,
																										Description:
																											item?.Description,
																									});
																								}}
																								style={{ cursor: 'pointer' }}
																							/>

																							<Grid minWidth={'70px'}>
																								<label
																									htmlFor={item?.Code}
																									style={{
																										color: '#1D60C5',
																										fontWeight: 600,
																										fontFamily: 'Poppins',
																										fontSize: {
																											xl: '15px',
																											lg: '10px',
																											md: '9px',
																											sm: '9px',
																											xs: '9px',
																										},
																										cursor: 'pointer',
																									}}
																								>
																									{`${item?.Code}`}
																								</label>
																							</Grid>
																						</Grid>
																						<Box
																							display={'flex'}
																							alignItems={'center'}
																						>
																							<CustomWidthTooltip
																								arrow
																								title={item?.Description}
																								placement="top-start"
																							>
																								<Typography
																									fontWeight={400}
																									fontFamily={'Poppins'}
																									sx={{
																										fontSize: {
																											xl: '15px',
																											lg: '10px',
																											md: '9px',
																											sm: '9px',
																											xs: '9px',
																										},
																									}}
																								>
																									{item?.Description?.length >
																									65
																										? item?.Description?.slice(
																												0,
																												65
																											) + '....'
																										: item?.Description}
																								</Typography>
																							</CustomWidthTooltip>
																						</Box>
																					</Box>
																					<Divider color={'#DCE8FB'} />{' '}
																				</Box>
																			);
																		})
																	: filteredFavCptCodes != null
																		? filteredFavCptCodes?.map((item, key) => {
																				return (
																					<Box
																						key={key}
																						sx={{ m: '8px 0 0 2rem' }}
																					>
																						<Box display={'flex'} gap={'10px'}>
																							<Grid
																								display={'flex'}
																								gap={'10px'}
																							>
																								<input
																									type="checkbox"
																									checked={selectedCheckboxes?.some(
																										(items) =>
																											items?.CPTCode ==
																											item?.Code
																									)}
																									id={item?.Code}
																									onClick={() => {
																										handleCheckboxChange({
																											CPTCode: item?.Code,
																											Description:
																												item?.CodeDescription,
																										});
																									}}
																									style={{
																										cursor: 'pointer',
																									}}
																								/>

																								<Grid minWidth={'70px'}>
																									<label
																										htmlFor={item?.Code}
																										style={{
																											color: '#1D60C5',
																											fontWeight: 600,
																											fontFamily: 'Poppins',
																											fontSize: {
																												xl: '15px',
																												lg: '10px',
																												md: '9px',
																												sm: '9px',
																												xs: '9px',
																											},
																											cursor: 'pointer',
																										}}
																									>
																										{`${item?.Code}`}
																									</label>
																								</Grid>
																							</Grid>
																							<Box
																								display={'flex'}
																								alignItems={'center'}
																							>
																								<CustomWidthTooltip
																									arrow
																									title={item?.CodeDescription}
																									placement="top-start"
																								>
																									<Typography
																										fontWeight={400}
																										fontFamily={'Poppins'}
																										sx={{
																											fontSize: {
																												xl: '15px',
																												lg: '10px',
																												md: '9px',
																												sm: '9px',
																												xs: '9px',
																											},
																										}}
																									>
																										{item?.CodeDescription
																											?.length > 65
																											? item?.CodeDescription?.slice(
																													0,
																													65
																												) + '....'
																											: item?.CodeDescription}
																									</Typography>
																								</CustomWidthTooltip>
																							</Box>
																						</Box>

																						<Divider color={'#DCE8FB'} />
																					</Box>
																				);
																			})
																		: ''}
															</Grid>
														)}
														<Box
															sx={{
																opacity: showCpt ? 1 : 0,
																height: showCpt ? '30px' : '0px',
																transition: 'all 0.5s ease-in',
															}}
															display="flex"
															gap={'5px'}
															justifyContent={'flex-end'}
															margin={'auto 5px 5px 5px'}
														>
															<Button
																onClick={() => {
																	setSearchCptData(null);
																	setShowCpt(false);
																	setSelectedCheckboxes([]);
																	setSearchRight('');
																}}
																variant="contained"
																sx={{
																	backgroundColor: '#ED2828',
																	fontSize: {
																		xl: '15px',
																		lg: '10px',
																		md: '9px',
																		sm: '9px',
																		xs: '9px',
																	},
																	'&:hover': {
																		backgroundColor: '#ED2828',
																	},
																}}
															>
																Cancel
															</Button>
															<Button
																disabled={
																	selectedCheckboxes?.length <= 0 ||
																	selectedCheckboxes == undefined
																		? true
																		: false
																}
																onClick={() => {
																	setCheckBoxCptCodes(selectedCheckboxes);
																	setSearchCptData(null);
																	setShowCpt(false);
																	setSearchRight('');
																}}
																variant="contained"
																sx={{
																	backgroundColor: '#D76A05',
																	fontSize: {
																		xl: '15px',
																		lg: '10px',
																		md: '9px',
																		sm: '9px',
																		xs: '9px',
																	},
																	'&:hover': {
																		backgroundColor: '#D76A05',
																	},
																}}
															>
																Add
															</Button>
														</Box>
													</Box>
												</Box>
												{/*box of cpt width Close iconbutton  */}
												{checkBoxCptCodes?.length > 0 && !showCpt && (
													<Box
														display={'flex'}
														flexDirection={'column'}
														gap={'5px'}
														m={'5px 0'}
														padding={'0 2px'}
														sx={{
															height: {
																xl: '24vh',
																lg: '29vh',
																md: '29vh',
																sm: '27vh',
																xs: '25vh',
															},
															overflow: 'auto',
														}}
													>
														{checkBoxCptCodes?.map((item, i) => (
															<Box key={i}>
																{changeCptCodes && (
																	<Box>
																		<Paper>
																			<CustomBoxDiagosis>
																				<Box
																					display={'flex'}
																					alignItems={'center'}
																					sx={{
																						fontSize: {
																							xl: '15px',
																							lg: '10px',
																							md: '9px',
																							sm: '9px',
																							xs: '9px',
																						},
																					}}
																				>
																					<CustomWidthTooltip
																						arrow
																						title={`${item?.CPTCode} [ ${item?.Description}]`}
																						placement="top-start"
																					>
																						<Typography
																							sx={{
																								color: '#065AD8',
																								fontWeight: 400,
																								fontFamily: 'Poppins',
																								fontSize: {
																									xl: '15px',
																									lg: '10px',
																									md: '9px',
																									sm: '9px',
																									xs: '9px',
																								},
																								lineHeight: '22.5px',
																							}}
																						>
																							{item.CPTCode +
																								` [ ${item?.Description?.length > 55 ? item?.Description.slice(0, 55) + '...' : item?.Description} ] `}
																						</Typography>
																					</CustomWidthTooltip>
																				</Box>
																				<Box>
																					<IconButton
																						sx={{
																							ml: 'auto',
																							width: '25px',
																							height: '25px',
																						}}
																						onClick={() =>
																							handleRemoveCheckbox(item)
																						}
																					>
																						<CloseIcon
																							sx={{ color: '#ED2828' }}
																						/>
																					</IconButton>
																				</Box>
																			</CustomBoxDiagosis>
																		</Paper>
																	</Box>
																)}
															</Box>
														))}
													</Box>
												)}
											</Box>
										</Box>
									</ClickAwayListener>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
				{/* Attachments and Clinical Notes */}
				<Box>
					<Grid container>
						{/* Attachments */}
						<Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
							<Grid container padding={'5px'} spacing={2}>
								{/* Additional notes */}
								<Grid item xl={6} lg={6} md={6} sm={12} xs={6}>
									<Typography
										color={'#BC1111'}
										fontWeight={500}
										fontFamily={'Poppins'}
										sx={{
											fontSize: {
												xl: '15px',
												lg: '10px',
												md: '9px',
												sm: '9px',
												xs: '9px',
											},
										}}
									>
										Additional Notes
									</Typography>
									<Box>
										<Box sx={{ display: 'flex', alignItems: 'center' }}>
											<TextField
												fullWidth
												multiline
												size="small"
												rows={2}
												name="select"
												value={additionalNotes}
												onChange={(e) => setAdditionalNotes(e.target.value)}
											/>
										</Box>
									</Box>
								</Grid>
								<Grid
									item
									xl={6}
									lg={6}
									md={6}
									sm={12}
									xs={12}
									display={'flex'}
									justifyContent={'space-between'}
								>
									<div>
										<Typography
											color={'#BC1111'}
											fontWeight={500}
											fontFamily={'Poppins'}
											sx={{
												fontSize: {
													xl: '15px',
													lg: '10px',
													md: '9px',
													sm: '9px',
													xs: '9px',
												},
											}}
										>
											Attachments
										</Typography>
										<Box>
											<Button
												variant="contained"
												component="label"
												size="small"
												sx={{
													background: '#2E68BA',
													color: 'white',
													fontSize: {
														xl: '15px',
														lg: '10px',
														md: '9px',
														sm: '9px',
														xs: '9px',
													},
												}}
											>
												Select Files
												<input
													ref={inputSelectedFile}
													type="file"
													multiple
													style={{ display: 'none' }}
													onChange={handleFileSelect}
													accept=".pdf,.doc,.docx,.xls,.xlsx, .png, .jpg,.jpeg"
												/>
											</Button>
										</Box>
									</div>
									<Box sx={{ width: '70%' }}>
										{selectedFiles.length > 0 && (
											<Box
												p={0}
												m={0}
												sx={{
													display: 'flex',
													flexDirection: 'column',
													padding: ' 5px 10px',
													height: '20vh',
													overflow: 'auto',
													border: '1px solid lightgray',
												}}
											>
												{selectedFiles.map((file, index) => (
													<Box
														key={index}
														display={'flex'}
														alignItems={'center'}
														gap={'5px'}
													>
														<Box
															display="flex"
															alignItems="center"
															justifyContent={'space-between'}
															sx={{
																borderRadius: '8px',
																background: '#EDFFF4',
																fontSize: {
																	xl: '15px',
																	lg: '10px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
																padding: '5px',
																margin: '5px',
																border: '1px solid lightgray',
																width: '90%',
															}}
														>
															<Typography variant="body2" sx={{ mr: 1 }}>
																{file.name}
															</Typography>
														</Box>
														<Box
															display={'flex'}
															alignItems={'center'}
															justifyContent={'center'}
															border={'1px solid black'}
															borderRadius={'5px'}
															sx={{ height: '25px', width: '25px' }}
														>
															<IconButton
																onClick={() => handleFileRemove(file)}
																sx={{
																	cursor: 'pointer',
																	height: '20px',
																	width: '20px',
																}}
															>
																<CloseIcon
																	sx={{
																		color: 'red',
																		height: '15px',
																		width: '15px',
																	}}
																/>
															</IconButton>
														</Box>
													</Box>
												))}
											</Box>
										)}
									</Box>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xl={0.6} lg={0.6} md={0.6} sm={12} xs={12}>
							<Divider
								orientation="horizontal"
								sx={{
									display: {
										md: 'none',
										lg: 'none',
										sm: 'block',
										xs: 'block',
									},
									backgroundColor: 'lightgray',
									width: '100%',
									height: '0.1px',
								}}
							/>
							<Divider
								sx={{
									display: {
										md: 'block',
										lg: 'block',
										sm: 'none',
										xs: 'none',
									},
									backgroundColor: 'lightgray',
									width: '1px',
									height: '100%',
									margin: 'auto auto auto auto',
								}}
							/>
						</Grid>
					</Grid>
				</Box>

				{/* Button */}
				<Box
					display={'flex'}
					justifyContent={'flex-end'}
					gap={'10px'}
					sx={{ padding: '15px 7px' }}
				>
					<Button
						onClick={() => navigate('/charges')}
						variant="contained"
						sx={{
							backgroundColor: '#ED2828',
							fontSize: {
								xl: '15px',
								lg: '10px',
								md: '9px',
								sm: '9px',
								xs: '9px',
							},
						}}
					>
						Cancel
					</Button>
					<Button
						disabled={
							status?.length <= 0 || status == undefined
								? true
								: // : providerId?.length <= 0 ||
									// 	  providerId == undefined ||
									// 	  providerId == null
									// 	? true
									// : checkBoxCptCodes?.length <= 0 ||
									// 	  checkBoxCptCodes == undefined
									// 	? true
									// 	: checkBoxDxCodes?.length <= 0 ||
									// 		  checkBoxDxCodes == undefined
									// 		? true
									patient?.length <= 0 ||
									  patient == null ||
									  patient == undefined
									? true
									: false
						}
						onClick={() => {
							createNewCharge(addCharge);
							setPatient(null);
						}}
						variant="contained"
						sx={{
							backgroundColor: '#D76A05',
							fontSize: {
								xl: '15px',
								lg: '10px',
								md: '9px',
								sm: '9px',
								xs: '9px',
							},
						}}
					>
						Add
					</Button>
				</Box>

				{/* SnackBar */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={1000}
					onClose={handleCloseSnackbar}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSnackbar}
						severity={postSucessfully === false ? 'error' : 'success'}
						variant="filled"
						sx={{
							// width: '100%',
							height: '3rem',
							textAlign: 'center',
							fontSize: {
								xl: '14px',
								lg: '14px',
								md: '14px',
								sm: '12px',
								xs: '12px',
							},
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={handleCloseSnackbar}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{postSucessfully === false ? 'Error' : 'Charge Added Successfully!'}
					</Alert>
				</Snackbar>
				{/* Modal Past visits */}
				<Modal
					open={openModal}
					// onClose={handleCloseModal}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Box
							display={'flex'}
							justifyContent={'space-between'}
							alignItems={'center'}
							bgcolor={'#3A7CE0'}
							padding={'5px 10px'}
							sx={{
								borderTopRightRadius: '10px',
								borderTopLeftRadius: '10px',
							}}
						>
							<Typography
								id="modal-modal-title"
								// variant="h6"
								fontSize={'16px'}
								align="center"
								fontWeight={'bold'}
								component="h2"
								color={'white'}
							>
								Past Visits
							</Typography>
							<IconButton
								sx={{ height: '20px', width: '20px', cursor: 'pointer' }}
								onClick={() => {
									handleCloseModal();
								}}
							>
								<CloseIcon sx={{ color: 'white' }} />
							</IconButton>
						</Box>
						<Box
							display={'flex'}
							flexDirection={'column'}
							gap={'5px'}
							margin={'3px 10px'}
							sx={{
								overflowY: 'auto',
							}}
						>
							{filteredVisitData?.map((item, key) => {
								const dxCodesAndDescriptions = [];
								for (let i = 1; i <= 12; i++) {
									const dxCode = item[`Dxcode${i}`];
									const dxDescription = item[`Dx${i}Description`];
									if (dxCode !== null && dxCode) {
										dxCodesAndDescriptions.push({
											DxCode: dxCode,
											Description: dxDescription,
										});
									}
								}
								return (
									<Box key={key}>
										<Box
											display={'flex'}
											justifyContent={'space-between'}
											alignItems={'center'}
											bgcolor={'#3A7CE0'}
											padding={'5px 10px'}
											sx={{
												border: '2px solid #3A7CE0',
												borderTopRightRadius: '10px',
												borderTopLeftRadius: '10px',
											}}
										>
											<Box display={'flex'} gap={'15px'}>
												<Typography
													id="modal-modal-title"
													// variant="h6"
													fontSize={'14px'}
													align="center"
													fontWeight={'bold'}
													component="h2"
													color={'white'}
												>
													Visit Date
												</Typography>
												<Typography
													id="modal-modal-title"
													// variant="h6"
													fontSize={'14px'}
													align="center"
													component="h2"
													color={'white'}
												>
													{formatAdmissionDate(item?.VisitDate)}
												</Typography>
											</Box>
										</Box>
										<Box
											display={'flex'}
											gap={'3px'}
											padding={'5px'}
											sx={{
												border: '2px solid #00000026',
												borderTop: 'none',
											}}
										>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												DX Codes:
											</Typography>
											{dxCodesAndDescriptions?.length === 0 && (
												<Box display={'flex'} gap={'5px'}>
													<Typography fontSize={'14px'}>No DX Added</Typography>
												</Box>
											)}

											{dxCodesAndDescriptions?.map((item, key) => {
												return (
													<Box key={key}>
														<Box display={'flex'} gap={'5px'}>
															<Typography fontSize={'14px'}>
																{`${item?.DxCode}` + ', '}
															</Typography>
														</Box>
													</Box>
												);
											})}
											{dxCodesAndDescriptions?.length != 0 && (
												<input
													value={dxCheckData}
													disabled={selectedDx && selectedDx !== item?.id}
													onChange={(e) => {
														const isChecked = e.target.checked;
														setDxCheckData(isChecked);
														setSelectedDxCodes(dxCodesAndDescriptions);
														if (isChecked) {
															setSelectedDx(e.target.id);
														} else {
															setSelectedDx(null);
														}
													}}
													type="checkbox"
													id={item?.id}
													style={{ cursor: 'pointer', marginLeft: 'auto' }}
												/>
											)}
										</Box>
										<Box
											display={'flex'}
											gap={'3px'}
											padding={'5px'}
											sx={{
												border: '2px solid #00000026',
												borderTop: 'none',
											}}
										>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												CPT Codes:
											</Typography>
											{item?.visit_cpts?.map((item, key) => {
												return (
													<Box key={key}>
														<Box display={'flex'} gap={'5px'}>
															<Typography fontSize={'14px'}>
																{`${item?.CPTCode}` +
																	`${item?.CPTCode?.length > 0 ? ', ' : 'No CPT Added'}`}
															</Typography>
														</Box>
													</Box>
												);
											})}
											{item?.visit_cpts[0].CPTCode != '' && (
												<input
													value={cptCheckData}
													disabled={selectedCpt && selectedCpt !== item?.id}
													onChange={(e) => {
														const isChecked = e.target.checked;
														setCptCheckData(isChecked);
														if (isChecked) {
															setCptCheckData(true);
															setSelectedCheckboxes(visitCpts);
															setSelectedCpt(e.target.id);
														} else {
															setCptCheckData(false);
															setSelectedCheckboxes([]);
															setSelectedCpt(null);
														}
														var visitCpts = item?.visit_cpts?.map((items) => ({
															CPTCode: items?.CPTCode,
															Description: items?.Description,
														}));
														setSelectedCheckboxes(visitCpts);
													}}
													type="checkbox"
													id={item?.id}
													style={{ cursor: 'pointer', marginLeft: 'auto' }}
												/>
											)}
										</Box>
									</Box>
								);
							})}
						</Box>
						<Box
							display={'flex'}
							justifyContent={'center'}
							gap={'14px'}
							margin={'5px 0'}
						>
							<Button
								variant="contained"
								sx={{ bgcolor: '#ED2828', width: '80px', py: '5px' }}
								onClick={() => {
									handleCloseModal();
								}}
							>
								Cancel
							</Button>
							<Button
								disabled={dxCheckData || cptCheckData ? false : true}
								variant="contained"
								sx={{ bgcolor: '#FD7702', width: '80px', py: '5px' }}
								onClick={() => {
									handleCloseModal();
									setCheckBoxDxCodes(selectedDxCodes);
									setCheckBoxCptCodes(selectedCheckboxes);
								}}
							>
								Add
							</Button>
						</Box>
					</Box>
				</Modal>
			</Box>
			{/* )} */}
		</>
	);
}
// custom styling
// Custom Box of Diagnosis Head
const DiagnosisBox = styled(Box)(({ theme }) => ({
	backgroundColor: '#2E68BA',
	padding: '8px 1rem',
	display: 'flex',
	justifyContent: 'space-between',
	borderTopLeftRadius: '5px',
	borderTopRightRadius: '5px',
}));
// custom Box of close Box of Diagosis
const CustomBoxDiagosis = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	backgroundColor: '#ECF4FF',
	padding: '0px 0px 0px 10px',
	border: '1px solid #00000026',
	borderRadius: '5px',
}));
// Modal
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: { xl: 500, lg: 500, sm: 450, md: 500, xs: 400 },
	maxHeight: '500px',
	bgcolor: 'background.paper',
	// boxShadow: 24,
	borderRadius: '10px',
	// p: '10px 15px 15px 15px',
	display: 'flex',
	flexDirection: 'column',
	gap: '5px',
};
// our custom tooltip code is here
const CustomWidthTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
		backgroundColor: 'gray',
		fontSize: '12px',
	},
});
// auto complete
const StyledTextField = styled(TextField)(({ theme }) => ({
	'& .MuiOutlinedInput-root': {
		borderRadius: '1.2rem',
		'& fieldset': {
			borderRadius: '1.2rem',
		},
		'&:hover fieldset': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused fieldset': {
			borderColor: theme.palette.primary.main,
		},
	},
	'& .MuiInputLabel-outlined': {
		transform: 'translate(14px, 7px) scale(1)',
		fontSize: '13px',
	},
	'& .MuiInputLabel-shrink': {
		transform: 'translate(14px, -6px) scale(0.75)',
		fontSize: '15px',
		color: '#f49546',
		padding: '0 5px',
	},
	'& ::placeholder': {
		fontSize: '10px',
		opacity: 1,
	},
}));
